import React from "react";

const CeilingFanImg = () => (
  <a href="/bldc-ceiling-fan">
    <img
      src="https://colorbots3.s3.ap-south-1.amazonaws.com/Product-category/Product-hover-knoxx.svg"
      alt="BLDC Ceiling Fans"
      height="190"
      width="190"
      className="img-thumbnail imgzoom img-fluid"
      loading="lazy"
      style={{ border: "none" }}
    />
  </a>
);

export default CeilingFanImg;
